import type { PropsWithChildren, ReactNode } from 'react';

import cn from 'classnames';

import { Title } from '../Title/Title';

import styles from './DataSection.module.scss';

interface IProp {
  titleText: string;
  titlePostfix?: ReactNode;
  wrapperClassName?: string;
  isTitleRequired?: boolean;
  titleClassName?: string;
  isTitleDisabled?: boolean;
}

export const DataSection = ({
  titleText,
  titlePostfix,
  wrapperClassName,
  isTitleRequired,
  titleClassName,
  isTitleDisabled,
  children,
}: PropsWithChildren<IProp>) => (
  <div className={cn(styles.wrapper, wrapperClassName)}>
    <div className={styles['title-wrapper']}>
      <Title
        isRequired={isTitleRequired}
        isDisabled={isTitleDisabled}
        className={titleClassName}
      >
        {`${titleText} :`}
      </Title>
      {titlePostfix}
    </div>
    {children}
  </div>
);
